<div class="container text-center text-white py-3 d-none d-md-block">

    <div class="welcome-to">Welcome to</div>
    <h1>Lakeshore</h1>
    <h1>Landing</h1>
    <h4>Your best choice to get to your island cottage anywhere between Gravenhurst and Bracebridge.</h4>
    <h4 class="mt-4">We offer a private members-only landing.  Please contact us for availability.</h4>

</div>
<div class="container text-center text-white py-3 d-block d-md-none">

    <div class="welcome-to">Welcome to</div>
    <h1 class="mobile">Lakeshore</h1>
    <h1 class="mobile">Landing</h1>
    <h4>Your best choice to get to your island cottage anywhere between Gravenhurst and Bracebridge.</h4>
    <h4 class="mt-4">We offer a private members-only landing.  Please contact us for availability.</h4>

</div>
<div class="container-fs p-0 p-md-5">

    <div class="row g-0">

        <div class="col-12 col-md-4 p-2 ">

            <div class="image-card-outer">
                <a [routerLink]="['/contact']" class="image-card border border-2 border-white">
                    <img src="/images/services-1.jpg" alt="" class="img-fluid">
                </a>
            </div>

        </div>
        <div class="col-12 col-md-4 p-2">

            <div class="image-card-outer">
                <a [routerLink]="['/contact']" class="image-card border border-2 border-white">
                    <img src="/images/services-2.jpg" alt="" class="img-fluid">
                </a>
            </div>

        </div>
        <div class="col-12 col-md-4 p-2">

            <div class="image-card-outer">
                <a [routerLink]="['/contact']" class="image-card border border-2 border-white">
                    <img src="/images/services-3.jpg" alt="" class="img-fluid">
                </a>
            </div>

        </div>
    </div>

</div>
